import { ICellEditorAngularComp } from 'ag-grid-angular';
import { ICellEditorParams } from 'ag-grid-community';
import { Component, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { LeaseTypeSelectorComponent } from '../Selectors/Lease-Type-Selector/leaseTypeSelector.component';

@Component({
    selector: 'entity-import-editor-onetime-v-recurring-selector',
    template: `
        <onetime-v-recurring-selector #selectorComponent
                                  [formControl]="selector"
                                  (changed)="onChanged($event)"></onetime-v-recurring-selector>`,
    standalone: false
})
export class EntityImportEditorOneTimeVRecurringSelectorRendererCellEditorComponent implements ICellEditorAngularComp {
    gridRow: Compliance.ImportGridRowGridModel;

    focusIn(): void {
    }

    focusOut(): void {
    }

    getValue(): any {
        return this.selector.value;
    }

    isCancelAfterEnd(): boolean {
        if (this.selectorComponent.value === '') {
            this._params.node.setDataValue(this._params.column.getColId(), null);
            return true;
        }
        return false;
    }

    isCancelBeforeStart(): boolean {
        return false;
    }

    isPopup(): boolean {
        return false;
    }

    selector: UntypedFormControl = new UntypedFormControl();
    values: Compliance.LeaseTypeModel[];

    @ViewChild('selectorComponent', { static: true }) selectorComponent: LeaseTypeSelectorComponent;

    private _params: ICellEditorParams;

    async agInit(params: ICellEditorParams): Promise<void> {
        this.gridRow = params.data as Compliance.ImportGridRowGridModel;

        this._params = params;
        this.selector.setValue(params.value);
    }

    onChanged(value: string) {
        if (!value) {
            this.selector.setValue(value);
            return;
        }
        if (this.selector.value !== value) {
            this.selector.setValue(value);
            this._params.node.setDataValue(this._params.column.getColId(), value);
        }
    }
}
